module.exports = __webpack_public_path__ + "img/documents_green.f49e8908.svg";